/**
 * @generated SignedSource<<5ad47123ff32eeb885f581975157385a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternPushStatusCard_status$data = {
  readonly androidDevices: number;
  readonly azureApiConnected: boolean;
  readonly azureApiError: string | null;
  readonly brandsNeedingAndroidMigration: number;
  readonly brandsNeedingIosMigration: number;
  readonly brandsWithAndroidCredentials: number;
  readonly brandsWithHub: number;
  readonly brandsWithIosCredentials: number;
  readonly dailyMetrics: ReadonlyArray<{
    readonly date: string;
    readonly deliveries: number;
    readonly taps: number;
  }>;
  readonly iosDevices: number;
  readonly notificationHubConnected: boolean;
  readonly notificationHubError: string | null;
  readonly notificationsSent30d: number;
  readonly pushDeliveries30d: number;
  readonly pushTaps30d: number;
  readonly tapRate: number;
  readonly totalActiveBrands: number;
  readonly totalRegisteredDevices: number;
  readonly " $fragmentType": "InternPushStatusCard_status";
};
export type InternPushStatusCard_status$key = {
  readonly " $data"?: InternPushStatusCard_status$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternPushStatusCard_status">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternPushStatusCard_status",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "azureApiConnected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "azureApiError",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notificationHubConnected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notificationHubError",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notificationsSent30d",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pushDeliveries30d",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pushTaps30d",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tapRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalRegisteredDevices",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iosDevices",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "androidDevices",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalActiveBrands",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandsWithHub",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandsWithIosCredentials",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandsWithAndroidCredentials",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandsNeedingIosMigration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandsNeedingAndroidMigration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PushNotificationDailyMetric",
      "kind": "LinkedField",
      "name": "dailyMetrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deliveries",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taps",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PlatformPushNotificationStatus",
  "abstractKey": null
};

(node as any).hash = "75974e5798b6044d2d98f6f2aebde533";

export default node;
